import React from 'react';

import GenericCardRenderItems from '../GenericCardRenderItems';

const RetEfectFideicomisoResumen = ({ data = {} }) => {
  const { RetEfectFideicomiso = {} } = data;

  return (
    <div className="d-block mt-2 mb-2">
      <GenericCardRenderItems
        data={RetEfectFideicomiso}
        width={200}
        subtitle="Retenciones efectuadas al fideicomiso"
        labels={labels(RetEfectFideicomiso)}
      />
    </div>
  );
};

const labels = (data = {}) => {
  return [
    {
      label: 'Monto',
      index: 'MontRetRelPagFideic',
    },
    {
      label: 'Descripción',
      index: 'DescRetRelPagFideic',
    },
  ];
};

export default RetEfectFideicomisoResumen;
